import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../../components/Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { formikAddRole, portalLayoutOption } from '../Constant';
import { createRole } from '../../../api/User';
import {failed, success} from "../../../utils/Tostify";
import NotAuthorize from '../../../components/notfound/NotAuthorize';
import { platformLayout } from '../../../utils/constants';

const AddRoles = ({setCurrentTab}) => {
  let role = localStorage.getItem("userRole");
  let token = useSelector(state => state.userReducer.token);
  let user = useSelector(state => state.userReducer.user);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch  = useDispatch();
  const formik = useFormik({
    ...formikAddRole,
    onSubmit: async (values) => {
        let res;
        try {
            values.createdBy = user?._id;
            setIsLoading(true);
            res = await createRole({ values, dispatch, token });
            if (res?.status == "SUCCESS") {
                setIsLoading(false);
                success(res?.message);
                formik.resetForm();
                setCurrentTab("rolesListing");
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    }
  });

  useEffect(() => {
   if(role == platformLayout.Organization){
     return <NotAuthorize/>;
   }
  }, []);

  return (
    <Fragment>
    {isLoading ? <Loader /> : null}
    <div className="organization_form_block organization_blk p-0 m-0 modal_change_color">
      <div className="">
        <div className="forms_block">
          <h6 className="title_blk mb-2 text-center">Create Role</h6>
          <Form onSubmit={formik.handleSubmit} onKeyDown={(e) => {
        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
            e.preventDefault();
        }
    }}>
            <div className="first_block">
              <Row>
                <Col lg={6} className="location_block">
                  <TextInput
                    keyField={"roleName"}
                    formik={formik}
                    label="Role Name"
                    type="text"
                    placeholder="Role Name"
                    value={formik.values.roleName}
                    onChange={(e) => formik.setFieldValue("roleName", e.target.value)}
                  />
                </Col>
                <Col lg={6} className="location_block">
                  <TextInput
                    keyField={"portalLayout"}
                    formik={formik}
                    label="Portal Layout"
                    placeholder={"Portal Layout"}
                    options={portalLayoutOption}
                    type="select"
                    value={formik.values.portalLayout}
                    onChange={(e) => formik.setFieldValue("portalLayout", e.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12} className="location_block">
                    <TextInput
                      keyField={"description"}
                      formik={formik}
                      label="Description"
                      type="textarea"
                      required={false}
                      placeholder="Role Description"
                      value={formik.values.description}
                      onChange={(e) => formik.setFieldValue("description", e.target.value)}
                    />
                </Col>
              </Row>
            </div>
            <div className="d-flex justify-content-between">
              <button className="save_btn" onClick={() => setCurrentTab("rolesListing")}>Cancel</button>
            <div className="d-flex gap-3">
              <button className="save_btn" type="submit">Save</button>
            </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </Fragment>
  );
};

export default AddRoles;
